export default __webpack_public_path__ + "static/elyxr-page-animation-sample-c34af0e7d7e36993235315ef7e37c1d9.mp4";